module.exports = __webpack_public_path__ + "static/media/sg.45fb3666.svg";